import React from "react";
import { createRoot } from "react-dom/client";
import ComplaintFormIsland from "./ComplaintFormIsland";
import "./complaintFormIsland.css";

const mountNode = document.getElementById("complaint-form-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<ComplaintFormIsland config={config} />);
  }
}
